import * as angular from 'angular';
import bugsnagJs from 'bugsnag-js';

angular.module('ApiErrorCatcher', [])
  .factory('errorHttpInterceptor', ['$q', '$log', 'bugsnagClient', ($q, $log, bugsnagClient) => {
    return {
      responseError(response) {
        const rejection = response || {};
        const data = rejection.data || {};

        let title = 'HTTP Response Error';

        if (rejection.status === -1) {
          title = 'Connection Error -1';
        } else if (data.message) {
          title = data.message;
        } else if (rejection.statusText) {
          title = rejection.statusText;
        }

        // Log server response
        $log.error(title, data);

        // Filter out some specific errors from being reported
        // Like rejected authentication and transaction declines
        const code = data.status_code || rejection.status;
        if ([403, 113, 114, 115, 116, 666, 4269].includes(code)) {
          return $q.reject(rejection);
        }

        bugsnagClient.notify(new Error(title), {
          beforeSend(report) {
            const config = rejection.config;

            if (!config) {
              return;
            }

            report.updateMetaData('debug', {
              url: config.url || null,
              payload: config.data || null,
            });

            report.updateMetaData('response', data);
          },
        });

        return $q.reject(rejection);
      },
    };
  }])
  .config(['$httpProvider', ($httpProvider) => {
    $httpProvider.interceptors.push('errorHttpInterceptor');
  }]);



// WEBPACK FOOTER //
// ./resources/assets/js/legacy/api-error-catcher.ts